export const ZLICK_GET_TRANSACTIONS = 'ZLICK_GET_TRANSACTIONS'
export const ZLICK_GET_TRANSACTIONS_ERROR = 'ZLICK_GET_TRANSACTIONS_ERROR'
export const ZLICK_TRANSACTION_METADATA = 'ZLICK_TRANSACTION_METADATA'
export const ZLICK_GET_USER_BILLING = 'ZLICK_GET_USER_BILLING'
